import { useSearchParams } from 'react-router-dom';

// Custom hook for better parameter management
function useQueryParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateParams = (updates) => {
    const newSearchParams = new URLSearchParams(searchParams);

    Object.entries(updates).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') {
        newSearchParams.delete(key);
      } else {
        newSearchParams.set(key, value);
      }
    });

    setSearchParams(newSearchParams);
  };

  const removeParam = (paramName) => {
    updateParams({ [paramName]: null });
  };

  const getParam = (paramName, defaultValue = '') => {
    return searchParams.get(paramName) || defaultValue;
  };

  // New method: Get all query parameters as an object
  const getAllParams = () => {
    const params = {};

    // Iterate through all search parameters and add them to the object
    searchParams.forEach((value, key) => {
      params[key] = value;
    });

    return params;
  };
  // Get complete query parameter string including the '?' prefix
  const getQueryString = () => {
    const queryString = searchParams.toString();
    return queryString ? `?${queryString}` : '';
  };

  return {
    searchParams,
    updateParams,
    removeParam,
    getParam,
    getAllParams,
    getQueryString,
  };
}
export default useQueryParams;
